<template>
    <div id="app">
        <img :src="item" class="item" v-for="(item,index) in images" :key="index" />
        <!-- <a href="tel:15705172020" class="phone">
            <img src="./assets/phone.png" class="phone-image">
        </a> -->
    </div>
</template>

<script>
export default {
    name: 'App',
    data(){
        return {
            images: [
                require('./assets/1.png'),
                require('./assets/2.png'),
                require('./assets/3.png'),
                require('./assets/4.jpg'),
                require('./assets/5.png'),
                require('./assets/6.png'),
                require('./assets/7.jpg'),
                require('./assets/8.jpg'),
                require('./assets/9.png'),
                require('./assets/10.jpg'),
                require('./assets/11.png'),
                require('./assets/12.jpg'),
                require('./assets/13.jpg'),
                require('./assets/14.jpg'),
                require('./assets/15.png'),
                require('./assets/16.png')
            ]
        }
    }
}
</script>

<style lang="scss">
#app {
    max-width: 750px;
    margin: 0 auto;
    font-size: 0;
    .item{
        width: 100%;
    }
    .phone{
        position: fixed;
        right: 10px;
        bottom: 50px;
        &-image{
            width: 58px;
            height: 58px;
        }
    }
}
</style>
